import { addClass } from 'gaspard'
import Tracking from './tracking'
import translations from './translations'
import queryParams from '../utils/queryParams'
import getJSON from '../utils/getJSON'
import dataLayer from './dataLayer'
import getIn from '../utils/getIn'
import isInApp from './isInApp'
import polyfill from '../utils/polyfill'
import isIE, { isSafari, isEdge } from '../utils/userAgent'

const publicPath = '/' + (process.env.BASE_URL ? '' : 'static/')

export default class Landing {
    static get props () {
        return ['path', 'project', 'landing', 'country', 'language', 'segment', 'trackingLabelPrefix', 'getApiDescription']
    }
    constructor ({ propsData = {}, project, projectPath, landing, trackingLabelPrefix, additionalBrands = [], skipMutationKeys = [], skipMutationTags = [], preventCustomInformation, getApiDescription = true }) {
        this.path = propsData.path || '/shared_res/agility/'
        this.project = propsData.project || project
        this.landing = propsData.landing || landing || project
        this.segment = queryParams.s || propsData.segment || 'anonymous'
        this.country = propsData.country || dataLayer.country
        this.language = propsData.language || dataLayer.language
        this.customProjectPath = projectPath
        this.customLanding = propsData.customLanding
        this.trackingLabelPrefix = propsData.trackingLabelPrefix || trackingLabelPrefix

        polyfill.arrayIndexOf()
        const htmlDocument = document.childNodes[1]
        if (isInApp) {
            addClass(htmlDocument, 'g_native')
        }
        addClass(htmlDocument, 'g_agility')

        // ACCESSIBILITY : add the g_keyTab class to enable blue focus
        document.addEventListener('keydown', (e) => {
            const keyCode = e.keyCode || e.which
            if (keyCode === 9) {
                if (e.currentTarget.keyDownTriggered) return
                e.preventDefault()
                addClass(htmlDocument, 'g_keyTab')
                e.currentTarget.keyDownTriggered = true
            }
        })

        let browsers
        const ieVersion = isIE()
        const edgeVersion = isEdge()
        const safariVersion = isSafari()
        if (ieVersion) {
            browsers = 'g_ie g_ie_' + ieVersion
        } else if (edgeVersion) {
            browsers = 'g_edge g_edge_' + edgeVersion
        } else if (safariVersion) {
            browsers = 'g_safari g_safari_' + safariVersion
        }
        if (browsers) {
            addClass(htmlDocument, browsers)
        }

        translations.getApiDescription = getApiDescription
        translations.setReplacements(additionalBrands)
        translations.setToSkip({
            keys: skipMutationKeys,
            tags: skipMutationTags
        })
    }

    get projectPath () {
        return publicPath
    }

    get landingPath () {
        return this.projectPath + this.landing + '/'
    }

    get dataFileUrl () {
        let url
        if (queryParams.preview) {
            url = ``
        } else {
            url = `${this.landingPath}data/${this.customLanding ? this.customLanding : this.landing}-${this.country.toUpperCase()}-${this.language.toUpperCase()}-${this.segment}.json`
        }
        return url
    }

    getJSON () {
        return getJSON(this.dataFileUrl)
            // .then(result => {
            //     const brandedNames = getIn('config.brandedNames', result)
            //     if (brandedNames) {
            //         translations.setReplacements(brandedNames)
            //     }
            //     translations.mutate(result)
            //     return result
            // })
    }

    getImgUrl ({ commons = false, project = false, folder = '', name, suffix = '', ext = 'jpg' }) {
        let base
        if (commons) {
            base = (process.env.NODE_ENV === 'development' ? publicPath : this.path) + 'commons/'
        } else if (project) {
            base = this.projectPath
        } else {
            base = this.landingPath
        }
        if (folder) {
            folder += '/'
        }
        return `${base}img/${folder}${name}${suffix}.${ext}`
    }
}
